const AUTH_TRANSLATE = {
  LOGIN: {},
};
export default AUTH_TRANSLATE;
